import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { OIDCWCConfig } from './oidc.models';
import { environment } from '../../../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class OidcScriptInjectorService {
    injectionConfig: OIDCWCConfig = {
        baseURL: environment.oidcWebComponent,
        modulePath: '/oiam-oauth-wc.esm.js',
        noModulePath: '/oiam-oauth-wc.js',
    };

    constructor(@Inject(DOCUMENT) private readonly dom: Document) {}

    injectOidcComponentScripts(): void {
        this.injectOidcScriptsForModuleBrowsers();
        this.injectOidcScriptsForNoModuleBrowsers();
    }

    private injectOidcScriptsForModuleBrowsers(): void {
        if (this.dom.getElementById('oidc-script-1')) {
            return;
        }

        const element: HTMLScriptElement = this.dom.createElement('script');
        element.id = 'oidc-script-1';
        element.type = 'text/javascript';
        element.type = 'module';
        element.src = this.injectionConfig.baseURL + this.injectionConfig.modulePath;

        this.dom.head.appendChild(element);
    }

    private injectOidcScriptsForNoModuleBrowsers(): void {
        if (this.dom.getElementById('oidc-script-2')) {
            return;
        }

        const element: HTMLScriptElement = this.dom.createElement('script');
        element.id = 'oidc-script-2';
        element.type = 'text/javascript';
        element.src = this.injectionConfig.baseURL + this.injectionConfig.noModulePath;
        element.noModule = true;

        this.dom.head.appendChild(element);
    }
}
